import { useEffect, useState } from 'react'
import { useReducedMotion } from 'react-native-reanimated'

/**
 * Whether a wait has run long enough to be worth drawing a ring for. A wait
 * that resolves inside `delayMs` never draws one, so a re-quote that lands in
 * a few frames doesn't flash a spinning animation.
 *
 * Reduced motion draws it straight away: there is no animation to suppress
 * then, only a busy cue to hold back.
 */
export function useDelayedSpinner(delayMs: number) {
  const shouldReduceMotion = useReducedMotion()
  const [hasDelayElapsed, setHasDelayElapsed] = useState(delayMs <= 0)
  useEffect(() => {
    if (shouldReduceMotion || delayMs <= 0) {
      return
    }
    const timeout = setTimeout(() => setHasDelayElapsed(true), delayMs)
    return () => clearTimeout(timeout)
  }, [shouldReduceMotion, delayMs])
  return shouldReduceMotion || delayMs <= 0 || hasDelayElapsed
}
